import React from 'react';
import { Route, createRoutesFromElements } from 'react-router-dom';
import PageLayout from 'src/components/common/PageLayout';
import { QUESTIONS_ROUTE, RESULTS_ROUTE, ROOT } from 'src/constants/routes';

import Main from './components/pages/Main';
import Questions from './components/pages/Questions';
import Results from './components/pages/Results';

export const Routes = (
  <>
    <Route path={ROOT} element={<PageLayout />}>
      <Route path={ROOT} element={<Main />} />
      <Route path={QUESTIONS_ROUTE} element={<Questions />} />
      <Route path={RESULTS_ROUTE} element={<Results />} />
    </Route>
  </>
);

export const routes = createRoutesFromElements(Routes);
export default routes;
